import {
  Button,
  Col,
  Modal,
  Row,
  Table,
  Typography,
} from "../../common/utils/antd-imports/AntdImports";
import "./ViewTermsPlan.css";
import {
  formatDate,
  formatToUSCurrency,
  formatTermType,
} from "../../common/utils/Utils";
const { Text } = Typography;
const ViewTermsPlan = ({
  viewTermsModal,
  setViewTermsModal,
  campaignTermsArray,
}) => {
  const columns = [
    {
      title: "Terms Plan",
      dataIndex: "term_type",
      render: (text, record) => <>{formatTermType(record?.term_type)}</>,
    },
    {
      title: "Amount",
      dataIndex: "payment_percentage",
      render: (text, record) => (
        <>{formatToUSCurrency(record?.payment_percentage)}</>
      ),
      align: "right",
    },
    {
      title: "Due Date",
      dataIndex: "due_date",
      align: "center",
      render: (text, record) => (
        <>
          {record?.due_date == "1970-01-01"
            ? "-"
            : formatDate(record?.due_date)}
        </>
      ),
    },
  ];

  return (
    <>
      <Modal
        open={viewTermsModal}
        footer={false}
        closable={false}
        className="terms-history-modal"
      >
        <div>
          <Row className="payment-terms-history-row">
            <Col>
              <Text className="terms-applies-main-text">
                Payment Terms Applied
              </Text>
            </Col>
            <Col>
              <Text className="review-terms-selected-text">
                Review the terms you've selected for this campaign.
              </Text>
            </Col>
          </Row>
          <Row className="terms-plan-history-table-row">
            <Table
              columns={columns}
              dataSource={campaignTermsArray}
              pagination={false}
              className="terms-plan-history-table"
              sticky
            />
          </Row>
          <Row className="terms-final-close-button-row">
            <Button
              type="primary"
              className="terms-close-button"
              onClick={() => setViewTermsModal(false)}
            >
              <Text className="terms-close-button-text">Close</Text>
            </Button>
          </Row>
        </div>
      </Modal>
    </>
  );
};
export default ViewTermsPlan;
